import React from 'react';
import {SvgIconDPC} from "../../index";
import riproduciIcon from "../../img/riproduci.svg";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

export default class DpcElencoPodcastCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {showPlayer : this.props.showPlayer};
        this.openPlayer = this.openPlayer.bind(this);
    }

    openPlayer(event) {
        event.preventDefault();
        this.setState({showPlayer: !this.state.showPlayer});
    }

    render() {
        return (
            <article className="card-wrapper card-space">
                <div className="card">
                    <div className="row">
                        
                        <div className="col-12 col-md-4 col-xl-2">
                        {this.props.urlImmagineAnteprima &&
                            <img src={this.props.urlImmagineAnteprima} className="card-img"
                                 alt={this.props.altImmagineAnteprima}/>
                                }
                        </div>
                        
                        <div className="col-12 col-md-6 col-xl-9">
                            <div className="card-body">
                                <div className="category-top">
                                    <span className="data">{this.props.data}</span>
                                </div>
                                <h3 className="h6 card-title">{this.props.titolo}</h3>
                                <div className="card-text"
                                     dangerouslySetInnerHTML={{__html: this.props.body ? this.props.body : ''}}/>
                            </div>
                        </div>
                        <div className="col-12 col-md-2 col-xl-1">
                            <div className="podcast-file-actions">
                                <ul>
                                    <li>
                                        <a href="#" onClick={this.openPlayer}>
                                            <svg className="icon" aria-hidden="true">
                                                <use xlinkHref={`${riproduciIcon}#riproduciIcon`}/>
                                            </svg>
                                            <span>Riproduci</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href={this.props.audioURL} download>
                                            <SvgIconDPC name={"download"}/>
                                            <span>Scarica</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {this.state.showPlayer &&
                        <div className="col-12">
                            <AudioPlayer src={this.props.audioURL}/>
                        </div>
                        }
                    </div>
                </div>
            </article>
        );
    }
}
